import JSONView from '.';
const defaultData = {
  str: '请绑定数据',
  num: 1234,
  bool: true,
  arr: ['string', 123, false, {
    prop1: 'prop'
  }]
};
const eventArguments = [{
  type: 'object',
  fields: [{
    id: 'key',
    type: 'string',
    title: '节点Key',
    description: '当前节点的key，例如 "name"'
  }, {
    id: 'path',
    type: 'string',
    title: '节点路径',
    description: '完整路径，例如 "user.name" 或者 "[2].title"'
  }, {
    id: 'value',
    title: '节点数据'
  }]
}];
/** @type {UICore.ComponentMeta} */
const JSONViewComponentMeta = {
  id: 'jsonView',
  name: 'JSON展示',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-select-tree_1636365117047.png',
  category: '展示',
  component: JSONView,
  bindings: [{
    id: 'value',
    prop: 'value',
    main: true
  }],
  events: [{
    id: 'click',
    name: '点击节点',
    arguments: eventArguments,
    desc: '可以通过 `$event` 访问当前点击的节点'
  }],
  methods: [{
    id: 'goto',
    title: '展开并跳转到节点',
    arguments: [{
      id: 'path',
      title: '目标路径',
      description: '可以是形如 `"user.tags[2]"` 的字符串，或者 `["user", "tags", 2]` 这样的数组'
    }]
  }],
  initialLayout: {
    style: {
      height: '400px'
    }
  },
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'any',
      title: 'value',
      default: defaultData
    }, {
      id: 'defaultExpandDepth',
      title: '默认展开层级数',
      type: 'number',
      default: 2,
      group: '行为'
    }, {
      id: 'filterStr',
      title: '过滤串',
      description: '可选，如果有值，则只展示 key 或 value 中含有“过滤串”的节点',
      type: 'string',
      default: '',
      group: '行为'
    }]
  }
};
export default JSONViewComponentMeta;
//# sourceMappingURL=meta.js.map
